import backendAxios from '../utils/backendAxios';

// Cuentas del usuario para recibir pagos + titular (nombre del perfil, no editable).
// Devuelve { titular, cuentas: [{ _id, clabe, banco, activa, fecha }] }.
export const getDatosBanco = async () => {
  try {
    const res = await backendAxios.get('/api/payments/banco');
    return res.data;
  } catch (err) {
    console.error('Error fetching datos bancarios', err);
    return { titular: '', cuentas: [] };
  }
};

// Agrega una cuenta. El titular NO se envía: el backend lo fija al nombre del perfil
// (la cuenta debe ser del propio usuario). Devuelve { success, cuentas } o { errores }.
export const agregarCuentaBanco = async (clabe) => {
  try {
    const res = await backendAxios.post('/api/payments/banco', { clabe });
    return res.data;
  } catch (err) {
    console.error('Error agregando cuenta bancaria', err);
    return err.response?.data || null;
  }
};

// Marca una cuenta como la activa (la que recibe los pagos). Devuelve { success, cuentas }.
export const activarCuentaBanco = async (cuentaId) => {
  try {
    const res = await backendAxios.patch(`/api/payments/banco/${cuentaId}/activar`);
    return res.data;
  } catch (err) {
    console.error('Error activando cuenta bancaria', err);
    return err.response?.data || null;
  }
};

// Quita una cuenta (soft delete). Devuelve { success, cuentas }.
export const eliminarCuentaBanco = async (cuentaId) => {
  try {
    const res = await backendAxios.delete(`/api/payments/banco/${cuentaId}`);
    return res.data;
  } catch (err) {
    console.error('Error eliminando cuenta bancaria', err);
    return err.response?.data || null;
  }
};

// --- Stripe Connect: cuenta del proveedor para recibir sus pagos (F3) ---

// Estado del onboarding Connect del proveedor. Al consultarlo, el backend sincroniza
// con Stripe y reintenta dispersar pagos retenidos si la cuenta ya quedó habilitada.
// Devuelve { disponible, conectado, detailsSubmitted, chargesEnabled, payoutsEnabled, completo, pendientes }.
export const getEstadoConnect = async () => {
  try {
    const res = await backendAxios.get('/api/payments/stripe/connect/estado');
    return res.data;
  } catch (err) {
    console.error('Error consultando estado Connect', err);
    return { disponible: false, conectado: false };
  }
};

// Inicia (o reanuda) el onboarding: devuelve la URL alojada por Stripe para redirigir.
export const iniciarOnboardingConnect = async () => {
  try {
    const res = await backendAxios.post('/api/payments/stripe/connect/onboarding');
    return res.data; // { url }
  } catch (err) {
    console.error('Error iniciando onboarding Connect', err);
    return err.response?.data || null;
  }
};

// Enlace al panel Express de Stripe (o reanuda el onboarding si faltan datos).
export const abrirDashboardConnect = async () => {
  try {
    const res = await backendAxios.post('/api/payments/stripe/connect/dashboard');
    return res.data; // { url, onboarding? }
  } catch (err) {
    console.error('Error abriendo panel Connect', err);
    return err.response?.data || null;
  }
};

// Pago de una reserva (monto, método, status y referencia SPEI/OXXO si aplica)
export const getPagoBooking = async (bookingId) => {
  try {
    const res = await backendAxios.get(`/api/payments/booking/${bookingId}`);
    return res.data;
  } catch (err) {
    return null; // 404: la reserva no tiene pago en línea
  }
};

// Concilia a demanda el pago de referencia (OXXO/SPEI) con Stripe: para cuando el cliente
// ya pagó y quiere que se refleje sin esperar el webhook. Devuelve el pago fresco + confirmado.
export const verificarPagoBooking = async (bookingId) => {
  try {
    const res = await backendAxios.post(`/api/payments/booking/${bookingId}/verificar`);
    return res.data;
  } catch (err) {
    return null;
  }
};
